<app-configuration-log
    [tids]="tids$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async"
    [pager]="pager$ | async"
    (pageChanged)="onPageChanged($event)">
</app-configuration-log>
